import React from 'react'
import Home from './Home'
import HomeDisplayCantique from './HomeDisplayCantique'

import { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CantiqueContextAPI } from '../Context/CantiqueContext';

const Display = () => {
  const { selectedCantique, allCantiques, catalogStatus, setSidebarOpen } = useContext(CantiqueContextAPI);
  const location = useLocation();
  const navigate = useNavigate();

  const linkedId = location.pathname.startsWith('/cantiques/') ? location.pathname.split('/')[2] : null;
  const linkNotFound = Boolean(linkedId)
    && (catalogStatus === 'ready' || catalogStatus === 'cached')
    && !allCantiques.some(c => c.id === linkedId);

  return (
    <div className="display">
        <div className="display__container">
               {/* show homepage if nothing has been selected yet */}
               {selectedCantique ? <HomeDisplayCantique /> : linkNotFound ? (
                 <div className="display__notFound" role="alert">
                   <p className="display__notFound__title">Cantique introuvable</p>
                   <p className="display__notFound__text">Ce lien ne correspond à aucun cantique. Il a peut-être été supprimé ou modifié.</p>
                   <div className="display__notFound__actions">
                     <button type="button" onClick={() => { navigate('/'); if (window.innerWidth <= 1000) setSidebarOpen(true); }}>Voir les cantiques</button>
                   </div>
                 </div>
               ) : <Home />}
            </div>
    </div>
  )
}

export default Display
